// Shared cache for frami data to prevent duplicate API calls
// Used by both FramiProvider and CompositionProvider

const CACHE_TTL = 60 * 1000; // 1 minute cache

let framiCache = {};
let isFetchingFrami = {};

export const getFramiFromCache = (framiId) => {
    const cached = framiCache[framiId];
    if (cached && (Date.now() - cached.timestamp) < CACHE_TTL) {
        return cached.data;
    }
    return null;
};

export const setFramiCache = (framiId, data) => {
    framiCache[framiId] = {
        data,
        timestamp: Date.now()
    };
};

export const isFramiFetching = (framiId) => {
    return isFetchingFrami[framiId] || false;
};

export const setFramiFetching = (framiId, value) => {
    isFetchingFrami[framiId] = value;
};

export const invalidateFramiCache = (framiId) => {
    if (framiId) {
        delete framiCache[framiId];
    } else {
        framiCache = {};
    }
};
